import { env } from 'utils/envManager'

export const getLegacyVideoSrc = (src: string): URL =>
	new URL(src, env.NEXT_PUBLIC_SITE_BASE_URL)
